import { useMutation } from 'react-query';

import {
  UpdateMemberEmailNotificationSettingsData,
  useRequest,
} from '@frontend/api';
import type { MutationFunction } from '@frontend/api';

export const useUpdateMemberEmailNotificationSettings: MutationFunction<
  UpdateMemberEmailNotificationSettingsData,
  UpdateMemberEmailNotificationSettingsData
> = ({ query, requestOptions, queryOptions } = {}) => {
  const urlPath = `/suppliers/member_email_notification_settings`;
  const request = useRequest(requestOptions);

  return useMutation((requestData) => {
    return request(urlPath, {
      query,
      init: {
        method: 'PATCH',
        body: requestData,
      },
    });
  }, queryOptions);
};
